import React, { useCallback, useRef } from "react";
import paper from "../../assets/paper.png";
import pencil from "../../assets/pencil.png";
import trash from "../../assets/trash.png";
import printer from "../../assets/Printer.png";
import pdf from "../../assets/pdf.png";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useContext } from "react";
import CurrencyFormat from "react-currency-format";
import moment from "moment";
import { accountService } from "../../services/accountService";
import { Grid } from "@mui/material";
import Item from "antd/lib/list/Item";
import GeneralModal from "../../helpers/GeneralModal";
import { createModal } from "react-modal-promise";
import {  SetPurchaseOrderMasterData, SetPurChaseOrderEdit } from "../../store/purchaseOrderAtom";
import { SetAddPurchaseReceive } from "../../store/purchaseReceiveAtom";
import LogicContext from "../../Context/LogicContext";
import PurchaseScroll from "./PurchaseScroll";
import Box from '@mui/material/Box';
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import PurchaseOrderBill from "./PurchaseOrderBill";
import PurchaseOrderReceiveTab from "./PurchaseOrderReceiveTab";


import PurchaseOrderPendingTab from "./PurchaseOrderPendingTab";
import PurchaseOrderHistory from "./PurchaseOrderHistory";
import PurchaseDetailsTable from "./PurchaseDetailsTable";
import DocumentViewer from "../../helpers/DocumentViewer";
import { formatCustomNumber } from "../../helpers/formatCustomNumber";
import { purchaseService } from "../../services/purchase.service";
import StatusBadge from "../../generals/StatusBadge";

const PurchaseOrderDetailsPage = () => {
  const [tabValue, setTabValue] = React.useState('1');
  const [selectedList, setSelectedList] = useState([]);
  const myPromiseModal = createModal(GeneralModal);
  const setPurchaseEdit = SetPurChaseOrderEdit();
  const setMasterData = SetPurchaseOrderMasterData();
  const setPendingReceive = SetAddPurchaseReceive();

  const { purchase_id } = useParams();
  const navigate = useNavigate();
  const logicContext = useContext(LogicContext);
  const [purchaseData, setPurchaseData] = useState({
    Purchase_Order_details: [],
    Count_Information: [],
    Pending_Receive: [],
    Action_Status: [],
  });
  const { pathname } = useLocation();
  var url = pathname.split("/");
  const currModuleId = url[1];
  const currModuleName = url[2];
  const currUserMenu = url[3];
  const mountRef = useRef(false);



  useEffect(() => {
    document.title = 'Purchase Order Details';
    mountRef.current = true;
    loadDetails();

    return () => {
      mountRef.current = false;

    };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [purchase_id]);


  const loadDetails = async()=> {
       accountService.getPurchaseDetails(purchase_id).then(response => {
         if (mountRef.current && response.data !== undefined) {
           if (response?.data) {
             setPurchaseData(response.data);
             setMasterData(prev => {
               let newList = prev['Purchase_Order_Info']?.map((item, index) => {
                 if (item?.Purchase_Order_Ref_No === response.data.Purchase_Order_Ref_No) {
                   return response.data;
                 } else {
                   return item;
                 }
               });
               return { ...prev, Purchase_Order_Info: newList };
             });
           } else {
             setPurchaseData({});
           }
         }
       });
  }

  function reloadPurchaseOrder(){
    accountService.getPurchaseDetails(purchase_id).then(response => {
      if (mountRef.current && response.data !== undefined) {
        if (response?.data) {
          setPurchaseData(response.data)
          setMasterData((prev)=> {
            let newList =  prev['Purchase_Order_Info'].map((item, index)=> {
               if (item?.Purchase_Order_Ref_No === response.data.Purchase_Order_Ref_No){
                 return response.data
               }else{
                 return item
               }
             })
             return ({...prev, Purchase_Order_Info: newList })
           });

        } else {
          setPurchaseData({})
        }

      }
    })
  }


  const reloadGeneralList = async () => {
    accountService.getPurchaseOrderList().then(response => {
      if (response?.data !== undefined) {
        setMasterData(response.data);
      }
    });
  }


  const editPurchaseOrder = async () => {
    const response = await myPromiseModal({
      title: "Modify Purchase Order", body: " Do you want to modify this record?"
   ,showInput:false, placeHolder:'' });
    if (response.decision === true) {
      setPurchaseEdit(purchaseData);
      navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/add-new`);
    }
  };


  const viewDetails = (id) => {
    navigate(`/${currModuleId}/${currModuleName}/${currUserMenu}/details/${id}`)
  }


  function onSelection(list) {
    let tempList = list?.filter(item => item.checked === true);
    setSelectedList(tempList)
  }


  const deletePurchaseOrder = async () => {
    await myPromiseModal({
      title: "confirm your Delete!",
      body: `Do you want to delete ${purchaseData?.Purchase_Order_Number} ?`,
      showInput:false, placeHolder:''}).then((response) => {
      if (response.decision === true) {
        let option = 8;
        let temp = `<a> <refno> ${purchaseData?.Purchase_Order_Ref_No} </refno> </a>`;
        let xml_string_refno = `<root> ${temp} </root>`;
        accountService.setPurchaseBulkAction({ xml_string_refno, option }).then(res => {
          if (res?.data !== undefined) {
            const { message_text } = res.data[0];
            logicContext.showToast(message_text, 'success');
            navigate(-1)
            reloadGeneralList();
          }
        }).catch((err) => {
          console.log('EERR ', err)
          // logicContext.showToast('Error', 'error');
        });
      }
    });
  };




   const singleActionPerform = useCallback(
        async action => {
          const result = await myPromiseModal({
            title: 'Confirm your action!',
            body: `This Purchase Order status will be ${action.Status_Name}?`,
            showInput: false,
            placeHolder: 'Enter message',
          });
  
          console.log("res ", result);
   
    
          if (result.decision === true) {
            const formData = { purchase_order_ref_no: purchase_id, option: action.Action_Option };
            accountService.purchaseAction(formData)
              .then(res => {
                if (res?.data !== undefined) {
                  const cleanResponse = logicContext.httpResponseManager(res.data?.[0] || res.data?.result_status?.[0]);
                  const { message_id, message_text } = cleanResponse;

                  if (message_id == 1) {
                    logicContext.showToast(message_text, 'success');
                    loadDetails();
                    reloadGeneralList();
                  }
                }
              })
              .catch(err => {
                logicContext.showToast("error", 'error');
              });
          }
        },
        [myPromiseModal]
      );
  



  const calculateSubTotal = (list) => {
    let result = 0
    list?.forEach(element => {
      result += element.Purchase_Amount
    });
    return result;

  }


  const calculateTotalQuantity = (list) => {
    let result = 0;
    let unitName = '';
    list?.forEach(element => {
      result += element.Item_Quantity
      unitName = element.Item_Unit_Name
    });
    return result + ` ${unitName}`

  }


  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };


  const customTabChange = (id) => {
    setTabValue(id);
  }


  const calculateTotal = (list) => {
    let result = 0;
    list?.forEach((element) => {
      result += element.Item_Quantity * element.Item_Rate;
    });
    let discountValue = purchaseData?.Discount_Value;
    let discountType = purchaseData?.Discount_Type_Id;
    if (discountValue && (discountType === 1 || discountType === 0)) {

      result = result - discountValue;
    }
    if (discountValue && discountType === 2) {

      let discount = (discountValue / 100) * result;
      result = Number(result) - Number(discount);
    }

    result +=  purchaseData?.Shipping_Charges || 0;
    return result?.toFixed(2);
  };



  function viewVendor(vendor_id) {
    navigate(`/${currModuleId}/${currModuleName}/${"vendors"}/details/${vendor_id}`
    );
  }


  function viewBillDetails(bill_id) {
    navigate(`/${currModuleId}/${currModuleName}/${"bills"}/details/${bill_id}`
    );
  }


  const markAsReceive  = (list, option)=> {
    try {
      let newList = []
      list.forEach((element, i)=> {
      if(element.Remaining_Quantity > 0){
        newList.push(element)
      }
      });
      if(newList.length > 0){
        setPendingReceive({Purchase_Order_Ref_No:purchaseData?.Purchase_Order_Ref_No,
          warehouse_id: purchaseData?.Delivery_To_Id, warehouse_name:purchaseData.Delivery_To_Name ,
          list:newList})
        navigate(`/${currModuleId}/${currModuleName}/${"purchase-receives"}/add-new?option=${option}`);
  
      }else{
        logicContext.showToast('No item(s) to receive!', 'info')
      }
    } catch (error) {
      logicContext.showToast('Cannot process receive items', 'info')
    }
  }




  return (
    <>
      <section className="mt-2 bg-white rounded-lg shadow-md p-6">
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <section className="max-w-6xl mx-auto">
              <div className="flex flex-wrap justify-between items-center">
                <div>
              
                </div>

            
              </div>
            </section>
          </Grid>

          <Grid item xs={12}>
            <section className="">
              <Grid container spacing={0}>
                <Grid item xs={2.8}>
                  <PurchaseScroll viewDetails={viewDetails} onSelection={onSelection} />
                </Grid>
                <Grid item xs={9.2}>
                  <section className="w-full z-50">
                    <div className="flex justify-end space-x-2">
                      {/* {magicButtons(purchaseData?.Purchase_Order_Status_Name)} */}

                      {purchaseData?.Action_Status?.length > 0 && (
                        <Dropdown>
                          <Dropdown.Toggle className="text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-md px-4 py-2" id="dropdown-basic">
                            ACTION
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="mt-1 shadow-lg border border-gray-200 rounded-md bg-white">
                            {purchaseData?.Action_Status?.map((option, i) => (
                              <Dropdown.Item className="hover:bg-gray-100" key={i} onClick={() => singleActionPerform(option)}>
                                <div className="text-sm text-gray-700 py-2 px-4">{option?.Status_Name}</div>
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      )}

                   
                      {/* buttons */}
                       <div className="flex justify-end no-print">
                          <div className="flex">
                            <button style={{ borderRadius: '5px' }} className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3">
                              <img src={paper} alt="" className="" />
                            </button>
                            <button
                              // onClick={() => handlePrint()}
                              style={{ borderRadius: '5px' }}
                              className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3"
                            >
                              <img src={pdf} alt="" className="" />
                            </button>
                            <button
                              onClick={editPurchaseOrder}
                              style={{ borderRadius: '5px' }}
                              className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 mr-3"
                            >
                              <img src={pencil} alt="" className="" />
                            </button>
                            <button
                              onClick={deletePurchaseOrder}
                              style={{ borderRadius: '5px' }}
                              className="px-3 h-[6vh] text-filterTextColor bg-filterColor lg:pt-1 ml-2"
                            >
                              <img src={trash} alt="" />
                            </button>
                          </div>
                        </div>
                      {/* buttons  end*/}
                    </div>

                    <section className="border border-gray-200 mx-2 mt-3 rounded-lg shadow-md bg-white">
                      {/* start tab */}
                      <Box sx={{ width: '100%', typography: 'body1' }}>
                        <TabContext value={tabValue}>
                          <Box className="ml-4 mt-2" sx={{ borderBottom: 1, borderColor: 'divider' }}>
                            <TabList onChange={handleTabChange} aria-label="lab API tabs example">
                              <Tab label="Details" value="1" />
                              {purchaseData?.Count_Information?.length > 0 && (
                                <Tab label={`History (` + purchaseData?.Count_Information[0].History_Count + ')'} value="2" />
                              )}

                              {purchaseData?.Count_Information?.length > 0 && (
                                <Tab label={`Bills (` + purchaseData?.Count_Information[0].Bill_Count + ')'} value="3" />
                              )}

                              {purchaseData?.Received?.length > 0 && (
                                <Tab label={`Receives (` + purchaseData?.Received.length + ')'} value="4" />
                              )}

                              {purchaseData?.Pending_Receive?.length > 0 && (
                                <Tab label={`Receive Pending (` + purchaseData?.Pending_Receive.length + ')'} value="5" />
                              )}
                            </TabList>
                          </Box>
                          <TabPanel value="1">
                          <section className="mt-6 p-6">
                        <div className="border border-gray-200 rounded-xl shadow-sm bg-white overflow-hidden">
                          {/* Header Section */}
                          <div className="bg-gradient-to-r from-blue-50 to-indigo-50 px-6 py-4 border-b border-gray-200">
                            <div className="flex justify-between items-start">
                              <div className="space-y-2">
                                <h2 className="text-2xl font-bold text-gray-800">
                                  {purchaseData?.Vendor_Name}
                                </h2>
                                <div className="flex flex-wrap gap-4 text-sm">
                                  <div>
                                    <span className="text-gray-600">PO Number:</span>
                                    <span className="ml-2 text-blue-600 font-semibold">
                                      {purchaseData?.Purchase_Order_Number}
                                    </span>
                                  </div>
                                  <div>
                                    <span className="text-gray-600">Reference:</span>
                                    <span className="ml-2 text-blue-600 font-semibold">
                                      {purchaseData?.Purchase_Order_Ref_No}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div>
                                <StatusBadge
                                  statusId={purchaseData?.Purchase_Order_Status_Id}
                                  statusName={purchaseData?.Purchase_Order_Status_Name}
                                  size="md"
                                />
                              </div>
                            </div>
                          </div>

                          {/* Details Section */}
                          <div className="p-6">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4">
                              {/* Vendor Information */}
                              <div className="space-y-3">
                                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                                  Vendor Information
                                </h3>
                                
                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Address</span>
                                  <span className="text-sm text-gray-800">
                                    {purchaseData?.Vendor_Address}
                                  </span>
                                </div>

                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Vendor Name</span>
                                  <span
                                    onClick={() => viewVendor(purchaseData?.Vendor_Id)}
                                    className="text-sm text-blue-600 font-medium cursor-pointer hover:text-blue-700 hover:underline transition-colors"
                                  >
                                    {purchaseData?.Vendor_Name}
                                  </span>
                                </div>

                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Phone Number</span>
                                  <span className="text-sm text-gray-800">
                                    {purchaseData?.Vendor_Mobile_Number}
                                  </span>
                                </div>
                              </div>

                              {/* Delivery Information */}
                              <div className="space-y-3">
                                <h3 className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-4">
                                  Delivery Information
                                </h3>

                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Order Date</span>
                                  <span className="text-sm text-gray-800">
                                    {purchaseData?.Purchase_Order_Date_String}
                                  </span>
                                </div>

                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Warehouse</span>
                                  <span className="text-sm text-gray-800 font-medium">
                                    {purchaseData?.Delivery_To_Name}
                                  </span>
                                </div>

                                <div className="flex flex-col space-y-1">
                                  <span className="text-xs text-gray-500">Delivery Address</span>
                                  <span className="text-sm text-gray-800">
                                    {purchaseData?.Delivery_To_Address}
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </section>
                          </TabPanel>
                          <TabPanel value="2">
                            <PurchaseOrderHistory />
                          </TabPanel>

                          <TabPanel value="3">
                            <PurchaseOrderBill
                              reloadPurchaseOrder={reloadPurchaseOrder}
                              viewBillDetails={viewBillDetails}
                              customTabChange={customTabChange}
                            />
                          </TabPanel>

                          <TabPanel value="4">
                            <PurchaseOrderReceiveTab
                              reloadPurchaseOrder={reloadPurchaseOrder}
                              viewVendor={viewVendor}
                              customTabChange={customTabChange}
                              tableData={purchaseData?.Received}
                            />
                          </TabPanel>

                          <TabPanel value="5">
                            <PurchaseOrderPendingTab 
                             markAsReceive={markAsReceive} tableData={purchaseData?.Pending_Receive} />
                          </TabPanel>
                        </TabContext>
                      </Box>
                      {/* end tab */}
                    </section>

                    <Grid item xs={12} className="border border-gray-200 mx-2 mt-2 p-4 rounded-lg shadow-md bg-white">
                      <PurchaseDetailsTable tableData={purchaseData?.Purchase_Order_details}></PurchaseDetailsTable>

                      <div className="my-2 border border-gray-200 py-4 px-4 rounded-md bg-gray-50">
                        <Grid item xs={12}>
                          <Grid container spacing={2}>
                            <Grid item xs={4}></Grid>

                            <Grid item xs={4}>
                              <div className="space-y-1 text-right">
                                <span className="text-blue-600 font-bold text-base">Sub Total:</span> <br/>
                                <span className="text-sm text-gray-600">Total Quantity</span> <br/>
                                <span className="text-sm font-bold text-gray-800">Discount</span> <br/>
                                <span className="text-sm font-bold text-gray-800">Adjustment</span> <br/>
                                <span className="text-sm font-bold text-gray-800">Shipping Fee</span> <br/>
                                <span className="text-xl font-bold text-gray-900">Total</span> <br/>
                              </div>
                            </Grid>
                            <Grid item xs={4}>
                              <div className="space-y-1 text-left">
                                <span className="text-blue-600 font-bold text-base">
                                  <CurrencyFormat
                                    value={parseFloat(calculateSubTotal(purchaseData?.Purchase_Order_details))?.toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'₦'}
                                  />
                                  {}{' '}
                                </span>
                                <br/>
                                <span className="text-sm text-gray-600">
                                  {calculateTotalQuantity(purchaseData?.Purchase_Order_details)}
                                  {}{' '}
                                </span>
                                <br/>
                                <span className="text-sm text-gray-600">
                                  {purchaseData?.Discount_Type_Id === 1 && (
                                    <CurrencyFormat
                                      value={formatCustomNumber(purchaseData?.Discount_Value)}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'₦'}
                                    />
                                  )}

                                  {purchaseData?.Discount_Type_Id === 2 && (
                                    <CurrencyFormat
                                      value={formatCustomNumber(purchaseData?.Discount_Value)}
                                      displayType={'text'}
                                      thousandSeparator={true}
                                      prefix={'%'}
                                    />
                                  )}
                                </span>
                                <br/>
                                <span className="text-sm text-gray-600">
                                  <CurrencyFormat
                                    value={formatCustomNumber(purchaseData?.Adjustment_Amount)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'₦'}
                                  />
                                  {}{' '}
                                </span>
                                <br/>
                                <span className="text-sm text-gray-600">
                                  <CurrencyFormat
                                    value={formatCustomNumber(purchaseData?.Shipping_Charges)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'₦'}
                                  />
                                  {}{' '}
                                </span>
                                <br/>
                                <span className="text-xl font-bold text-gray-900">
                                  <CurrencyFormat
                                    value={parseFloat(calculateTotal(purchaseData?.Purchase_Order_details))?.toFixed(2)}
                                    displayType={'text'}
                                    thousandSeparator={true}
                                    prefix={'₦'}
                                  />
                                  {}{' '}
                                </span>
                              </div>
                            </Grid>
                          </Grid>
                        </Grid>
                      </div>
                    </Grid>
                    <DocumentViewer fileList={purchaseData?.Attachments} />
                  </section>
                </Grid>
              </Grid>

              {/* w-[56.3vw] */}
            </section>
          </Grid>
        </Grid>
      </section>
    </>
  );
};

export default PurchaseOrderDetailsPage;